import type { CancelTokenSource } from '@hotjar/api-base-client';
import { client } from '@hotjar/api-base-client';
import type { OrderRequestDto } from '../order/dto';
import {
  mapSubscriptionAmendmentRequestModelToDto,
  mapSubscriptionCreationRequestModelToDto,
  mapSubscriptionReactivationRequestModelToDto,
} from '../order/mapper';
import type {
  SubscriptionAmendmentRequest,
  SubscriptionCreationRequest,
  SubscriptionReactivationRequest,
} from '../order/model';
import type { PreviewCostsResponse } from './model';

const clientBaseConfig = {
  url: '/api/checkout/orders/preview/v1',
  method: 'POST' as const,
};

export async function previewSubscriptionCreationCosts(
  data: SubscriptionCreationRequest,
  cancelTokenSource: CancelTokenSource,
): Promise<PreviewCostsResponse> {
  return client<
    PreviewCostsResponse,
    never,
    SubscriptionCreationRequest,
    OrderRequestDto<'customer_and_subscription_creation_revised_order'>
  >({
    ...clientBaseConfig,
    data,
    cancelTokenSource,
    mapRequestData: mapSubscriptionCreationRequestModelToDto,
  });
}

export async function previewSubscriptionReactivationCosts(
  data: SubscriptionReactivationRequest,
  cancelTokenSource: CancelTokenSource,
): Promise<PreviewCostsResponse> {
  return client<
    PreviewCostsResponse,
    never,
    SubscriptionReactivationRequest,
    OrderRequestDto<'reactivate_subscription_order'>
  >({
    ...clientBaseConfig,
    data,
    cancelTokenSource,
    mapRequestData: mapSubscriptionReactivationRequestModelToDto,
  });
}

export async function previewSubscriptionAmendmentCosts(
  data: SubscriptionAmendmentRequest,
  cancelTokenSource: CancelTokenSource,
): Promise<PreviewCostsResponse> {
  return client<
    PreviewCostsResponse,
    never,
    SubscriptionAmendmentRequest,
    OrderRequestDto<'amend_subscription_order'>
  >({
    ...clientBaseConfig,
    data,
    cancelTokenSource,
    mapRequestData: mapSubscriptionAmendmentRequestModelToDto,
  });
}
